import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/state/authStore';
import { LoadingState } from '@/components/feedback/LoadingState';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);
  const location = useLocation();

  if (isLoading) return <LoadingState variant="spinner" />;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
